var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('p',{staticClass:"text_size_16 margin-right-10"},[_c('i',{staticClass:"el-icon-s-custom"}),_vm._v("\n    "+_vm._s(_vm.userInfo.userName)+"\n  ")]),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.logout}},[_vm._v("退出登录")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-236393a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/container/header/index.vue
// module id = null
// module chunks = 